import { Store } from 'laco'

const colorState = new Store({
  primary: '#f00',
  secondary: '#6BA314',
  background: '#fff',
  background600: '#fff',
  background700: '#F8F8F8',
  background800: '#eef0f1',
  background900: '#e3e6e8',
  backgroundInverted: '#6a7581',
  mainBackground: '#cbcbd226',
  borderColor: '#E7E7E7',
  text: '#000',
  textLight: '#888',
  textOnPrimary: '#fff',
  textPrimary: '#FF0000',
  textInverted: '#ddd',
  blueText: '#5E8CB1',
  blue: '#2F76FF',
  red: '#FD0400',
  redMuted: '#e8413f',
  green: '#6BA314',
  blueBtn: '#17a2b8'
})

const layoutStore = new Store({
  maxWidth: '1200px',
  breakpoints: {
    mobile: '800px',
    tablet: '1200px'
  }
})
const styleStore = new Store({
  borderRadius: '8px'
})

let colors = colorState.get()

let layout = layoutStore.get()

let styles = styleStore.get()

colorState.subscribe(() => {
  colors = colorState.get()
})
layoutStore.subscribe(() => {
  layout = layoutStore.get()
})
styleStore.subscribe(() => {
  styles = styleStore.get()
})

const clubTemplate = {
  logo: { _text: '' },
  publickey: {},
  cmd_button_mode: { _text: 'TCODE' },
  cmd_url: {},
  cmd_text: {},
  customtext: { _text: '' },
  customurl: { _text: '' },
  offers1: {},
  offers2: {},
  offers3: {},
  offers4: {},
  offers5: {},
  offers6: {},
  mainbtn1: {
    title: { _text: '' },
    url: { _text: '' }
  },
  mainbtn2: {
    title: { _text: '' },
    url: { _text: '' }
  },
  menubtn1: {
    icon: { _text: '13' },
    title: { _text: '' },
    url: { _text: '' }
  },
  menubtn2: {
    icon: { _text: '13' },
    title: { _text: '' },
    url: { _text: '' }
  },
  menubtn3: {
    icon: { _text: '13' },
    title: { _text: '' },
    url: { _text: '' }
  },
  menubtn4: {
    icon: { _text: '13' },
    title: {},
    url: {},
    cmenu: { _text: 'true' }
  },
  menubtn5: {
    icon: { _text: '13' },
    title: {},
    url: {},
    cmenu: { _text: 'true' }
  },
  menubtn6: {
    icon: { _text: '13' },
    title: {},
    url: {},
    cmenu: { _text: 'true' }
  },
  couponbtn: {
    icon: { _text: '7' },
    showbtn: { _text: 'false' },
    title: { _text: 'Resources' },
    coupondata: {
      sponsorheader: { _text: 'Resources' },
      image1: {},
      url1: {},
      image2: {},
      url2: {},
      image3: {},
      url3: {},
      image4: {},
      url4: {},
      image5: {},
      url5: {},
      image6: {},
      url6: {}
    }
  },
  clubName: '',
  clubId: '',
  customLinks: []
}

const icons = [
  { text: 'FAQ', value: 13 },
  { text: 'Shopping', value: 1 },
  { text: 'Website', value: 2 },
  { text: 'Facebook', value: 3 },
  { text: 'Twitter', value: 4 },
  { text: 'Merchandise', value: 5 },
  { text: 'Tag', value: 6 },
  { text: 'Settings', value: 7 },
  { text: 'Diamond', value: 8 },
  { text: 'Pinterest', value: 9 },
  { text: 'YouTube', value: 10 },
  { text: 'Instagram', value: 11 },
  { text: 'News', value: 12 },
  { text: 'Calendar', value: 14 },
  { text: 'News', value: 15 },
  { text: 'Maps', value: 16 },
  { text: 'Videos', value: 17 },
  { text: 'Merchandise', value: 18 },
  { text: 'Signal', value: 19 },
  { text: 'Team', value: 20 }
]

export { colorState, layoutStore, styleStore, colors, layout, styles, clubTemplate, icons }
